import { render } from "./IncomeCategoryPage.vue?vue&type=template&id=5b05feb8&scoped=true&ts=true"
import script from "./IncomeCategoryPage.vue?vue&type=script&lang=ts"
export * from "./IncomeCategoryPage.vue?vue&type=script&lang=ts"

import "./IncomeCategoryPage.vue?vue&type=style&index=0&id=5b05feb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b05feb8"]])

export default __exports__